import { restoreCurrentRuleWatchUrl } from './crossAppNavigation';

restoreCurrentRuleWatchUrl();
